import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ReportDetailService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) { }

    getReport(id, customerId, startDate, endDate, incompletedJobs): Observable<any> {
        const url = this.urlPrefix + 'export/' + id;
        let params = new HttpParams();

        if (customerId != null) {
            params = params.set('customer', customerId);
        }

        if (startDate != null && endDate != null) {
            params = params.set('start-date', startDate);
            params = params.set('end-date', endDate);
        }
        if (incompletedJobs != 0) {
            params = params.set('incompleted', incompletedJobs);

        }

        return this.httpClient
            .get(url,
                {
                    params: params,
                    observe: 'response',
                    responseType: 'arraybuffer'
                })
            .map(
                res => {
                    if (res.status === 200) {
                        return res;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }

    getSurvey(startDate, endDate, customerId): Observable<any> {
        const url = this.urlPrefix + 'survey/report/excel';
        let params = new HttpParams();
        if (customerId != null) {
            params = params.set('customer', customerId);
        }
        if (startDate != null && endDate != null) {
            params = params.set('start-date', startDate);
            params = params.set('end-date', endDate);
        }

        return this.httpClient
            .get(url,
                {
                    params: params,
                    observe: 'response',
                    responseType: 'arraybuffer'
                })
            .map(
                res => {
                    if (res.status === 200) {
                        return res;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/report/report-detail/report-detail.service.ts